import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=f3b0f4c8&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=f3b0f4c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b0f4c8",
  null
  
)

export default component.exports